import { makeZeroArgHook } from "../../../utils/makeZeroArgHook";
import getClientsV2 from "../../requests/persons/getClientsV2";
import { clientsUrl } from "../../requests/urls";
const useGetClients = makeZeroArgHook(getClientsV2, () => [clientsUrl("v2")]);
export default useGetClients;
//# sourceMappingURL=useGetClientsV2.js.map